import React from 'react';

import AutoResizingTextarea from '../../components/AutoResizingTextarea';

const PostEnhancerHero = ({
  subreddit,
  setSubreddit,
  username,
  setUsername,
  postTitle,
  setPostTitle,
  postContent,
  setPostContent,
  handleEnhance,
  loading,
  handleFocus
}) => {
  return (
    <div className="relative rounded-2xl bg-gradient-to-br from-[var(--color-primary-accent)] via-[#1A535C] to-[var(--color-secondary-accent)] text-white p-4 md:p-12 md:pb-2 mb-10 shadow-2xl shadow-primary/20 flex flex-col" data-testid="postEnhancerHero-container">
      <div className="absolute inset-0 bg-black/40 rounded-2xl"></div>
      <div className="relative z-10 text-center">
        <h1 className="text-5xl md:text-7xl font-black tracking-tighter mb-4">Enhance Your Post</h1>
        <p className="text-xl md:text-2xl max-w-5xl mx-auto text-white/90 leading-relaxed mt-6 mb-8">
          Adapt your writing to each community's unique style and rules - offering smart suggestions to refine your title and content for maximum engagement.
        </p>

        <div id="post-enhancer-form-container" className="bg-white/10 backdrop-blur-sm border border-white/20 pt-6 pb-1 px-8 rounded-xl max-w-5xl mx-auto">
          <form onSubmit={handleEnhance} className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center" data-testid="postEnhancerHero-form">
            <div className="relative">
              <label htmlFor="subreddit-url" className="sr-only">Subreddit URL</label>
              <input
                id="subreddit-url"
                name="post-enhancer-subreddit"
                className="w-full bg-white rounded-md pl-4 pr-4 py-4 text-black placeholder:text-gray-500 focus:border-2 focus:border-[var(--color-primary-accent)] transition border border-white/20"
                placeholder="Enter Subreddit or URL"
                type="text"
                value={subreddit}
                onFocus={handleFocus}
                onChange={(e) => setSubreddit(e.target.value)}
                required
                data-testid="postEnhancerHero-subredditInput"
              />
            </div>
            <div className="relative">
              <label htmlFor="username-url" className="sr-only">Username or Profile URL</label>
              <input
                id="username-url"
                name="post-enhancer-username"
                className="w-full bg-white rounded-md pl-4 pr-4 py-4 text-black placeholder:text-gray-500 focus:border-2 focus:border-[var(--color-primary-accent)] transition border border-white/20"
                placeholder="Enter Username or Profile URL (Optional)"
                type="text"
                value={username}
                onFocus={handleFocus}
                onChange={(e) => setUsername(e.target.value)}
                data-testid="postEnhancerHero-usernameInput"
              />
            </div>
            <div className="md:col-span-2">
              <input
                id="post-title"
                name="post-enhancer-title"
                className="w-full bg-white rounded-md pl-4 pr-4 py-4 text-black focus:border-2 focus:border-[var(--color-primary-accent)] transition border border-white/20"
                placeholder="Enter your post title"
                type="text"
                value={postTitle}
                onFocus={handleFocus}
                onChange={(e) => setPostTitle(e.target.value)}
                required
                data-testid="postEnhancerHero-postTitleInput"
              />
            </div>
            <div className="md:col-span-2">
              <AutoResizingTextarea
                id="post-content"
                name="post-enhancer-content"
                rows="1"
                className="w-full bg-white rounded-md pl-4 pr-4 py-2 text-black focus:border-2 focus:border-[var(--color-primary-accent)] transition resize-none min-h-[112px] max-h-60 overflow-y-auto border border-white/20 pt-4 text-start"
                placeholder="Enter your post content"
                value={postContent}
                onFocus={handleFocus}
                onChange={(e) => setPostContent(e.target.value)}
                required
                data-testid="postEnhancerHero-postContentInput"
              />
            </div>
            <div className="md:col-span-2">
              <button
                type="submit"
                id="enhance-post-button"
                disabled={loading}
                className="w-full bg-[var(--color-primary-accent)] text-white font-semibold py-3 px-6 rounded-lg hover:bg-[var(--color-secondary-accent)] transition-colors shadow-lg"
                data-testid="postEnhancerHero-enhanceButton"
              >
                {loading ? (
                  <div className="spinner"></div>
                ) : (
                  <span className="flex items-center justify-center gap-2">
                    <span className="material-symbols-outlined">auto_awesome</span>
                    Enhance
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="mt-4 text-center relative z-10">
        <p className="text-white/70 text-xs mb-2 leading-relaxed">
          This service analyzes publicly available Reddit content. Usage is subject to
          <a href="https://www.redditinc.com/policies/data-api-terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-white mx-1">Reddit's API Terms</a>
          and our
          <a href="/privacy-policy" className="underline hover:text-white mx-1">Privacy Policy</a>.
          <br />
        </p>
      </div>
    </div>
  );
};

export default PostEnhancerHero;
